import React, { Component } from 'react';
import { Router, IndexRoute, Route } from 'react-router';
import Immutable from 'immutable';
import {firebaseRoot} from './utils/firebase-utils';
import ReactFireMixin from 'reactfire';
import 'react-tap-event-plugin';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';

require('../public/static/css/styles.scss');

const App = React.createClass({
    contextTypes: {
        history: React.PropTypes.object.isRequired
    },

    render() {
        return (
            <ReactCSSTransitionGroup
                className="slider-wrap site-public"
                component="div"
                transitionName={this.context.history.isGoingBack() ? 'slideback' : 'slideforward'}
                transitionEnterTimeout={250}
                transitionLeaveTimeout={250}
            >
                <div key={this.props.location.pathname} className="slider slider-transition">
                    {this.props.children}
                </div>
            </ReactCSSTransitionGroup>
        );
    }
});

export default App;


/** WEBPACK FOOTER **
 ** ./src/App.js
 **/